import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public saveToLocalStorage(key: string, value: any) {
    try {
      sessionStorage?.setItem(key, value);
    } catch (_) {}
    return true;
  }

  public getFromLocalStorage(key: string) {
    try {
      if (key) {
        return sessionStorage?.getItem(key);
      }
    } catch (_) {}
    return null;
  }

  public removeFromLocalStorage(key: string) {
    try {
      sessionStorage?.removeItem(key);
    } catch (_) {}
    return true;
  }
}
